'use strict';

const fuzzyRegExpCache = {};

const join = (head, tail) => {
  let nTail = tail;
  if (tail.length === 0) {
    nTail = [head];
  } else if (head.end === nTail[0].start) {
    nTail[0].start = head.start;
  } else {
    nTail.unshift(head);
  }
  return nTail;
};

const convertSimple2RegExpPattern = (pattern) => {
  return pattern.replace(/[\-\\\{\}\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, '\\$&').replace(/[\*]/g, '.*');
};


const matchesSubsString = (word, wordToMatchAgainst, i, j) => {
  if (i === word.length) {
    return [];
  }

  if (j === wordToMatchAgainst.length) {
    return null;
  }

  if (word[i] === wordToMatchAgainst[j]) {
    const result = matchesSubsString(word, wordToMatchAgainst, i + 1, j + 1);
    if (result) {
      return join({ start: j, end: j + 1 }, result);
    }
  }

  return matchesSubsString(word, wordToMatchAgainst, i, j + 1);
};
const matchesFuzzy = (word, wordToMatchAgainst) => {
  let nWord = word;
  if (typeof word !== 'string' || typeof wordToMatchAgainst !== 'string') {
    return null; // return early for invalid input
  }
  nWord = nWord.replace(/-/g, '');
  // Form RegExp for wildcard matches
  let regexp = fuzzyRegExpCache[nWord];
  if (!regexp) {
    regexp = new RegExp(convertSimple2RegExpPattern(nWord), 'i');
    fuzzyRegExpCache[nWord] = regexp;
  }

  // RegExp Filter
  const match = regexp.exec(wordToMatchAgainst);
  if (match) {
    return [{ start: match.index, end: match.index + match[0].length }];
  }

  // Default Filter
  return matchesSubsString(nWord.toLowerCase(), wordToMatchAgainst.toLowerCase(), 0, 0);
};

function wrapWithBold(s, range) {
  const head = s.substring(0, range.start);
  const middle = s.substring(range.start, range.end);
  const tail = s.substring(range.end);
  return `${head}<strong>${middle}</strong>${tail}`;
}

const highlightWords = (wordToChange, highlightList) => {
  if (highlightList === null) {
    return wordToChange;
  }
  const nHighlightList = highlightList.reverse().reduce(
    (result, range) => wrapWithBold(result, range),
    wordToChange);
  return nHighlightList;
};


module.exports = {
  highlightWords,
  matchesFuzzy,
  join,
  convertSimple2RegExpPattern,
  matchesSubsString,
  wrapWithBold,
};
